import React from 'react';
import { useMonsterTokenStyle } from '../utils/clientSettings';
import { AncientOneCard, AncientOneCardProps } from './AncientOneCard';
import { AncientOneDigitalCard } from './AncientOneDigitalCard';

/** Use the saved Artwork preference for every Ancient One display. */
export const AncientOneDisplay: React.FC<AncientOneCardProps> = (props) => {
  const artwork = useMonsterTokenStyle();
  return artwork === 'Digital'
    ? <AncientOneDigitalCard {...props} />
    : <AncientOneCard {...props} />;
};
